import React from 'react';

import Notification from '../../../components/Notification';
import Operator from './Operator';
import NumericFilter from './NumericFilter';
import TextFilter from './TextFilter';
import BooleanFilter from './BooleanFilter';
import SingleSelectFilter from './SingleSelectFilter';
import MultiSelectFilter from './MultiSelectFilter';
import DateTimeFilter from './DateTimeFilter';
import CatalogRadioFilter from './CatalogRadioFilter';
import MultiNumericFilter from './MultiNumericFilter';

function Filter({question, catalog, filter, onChange, validations}) {
  const FilterType = getFilter(question);

  return (
    FilterType ? (
      <>
        <Operator
          question={question}
          operators={FilterType.operators || []}
          value={filter.operator}
          onChange={operator => onChange({...filter, operator, values: []})}
        />
        {filter.operator && (
          <FilterType
            question={question}
            filter={filter}
            onChange={onChange}
            catalog={catalog}
            validations={validations}
          />
        )}
      </>
    ) : (
      <Notification warning>You cannot apply a filter to this question</Notification>
    )
  );
}

Filter.validate = validateFilter;

function getFilter(question) {
  switch (question.type) {
    case 'NUMERIC':
    case 'MEASURED_NUMERIC':
      return NumericFilter;
    case 'CODE_GENERATOR':
    case 'SCANNED_CODE':
    case 'TEXT':
      return TextFilter;
    case 'BOOLEAN':
      return BooleanFilter;
    case 'RADIO':
      return SingleSelectFilter;
    case 'CHECKBOXES':
      return MultiSelectFilter;
    case 'DATETIME':
      return DateTimeFilter;
    case 'CATALOG_RADIO':
    case 'CATALOG_CHECKBOX':
      return CatalogRadioFilter;
    case 'MULTI_NUMERIC':
      return MultiNumericFilter;
    default:
      return null;
  }
}

function validateFilter(question, filter) {
  const delegate = getFilter(question);
  return delegate.validate(filter);
}

export default Filter;
